export default "__VITE_ASSET__fbe1138d__"